import React from 'react'
import PropTypes from 'prop-types'
import useStyles from 'substyle'

const defaultStyle = {
  fontWeight: 'inherit',
  transition: 'opacity 0.15s ease, background-color 0.15s ease',
}

const Mention = ({ display, style, className, classNames, isHighlighted = false, id, trigger = '@', markup = '@[__display__](__id__)', displayTransform, onAdd, onRemove, renderSuggestion = null, isLoading = false, appendSpaceOnAdd = false, maxMentions = null }) => {
  const styles = useStyles(defaultStyle, { style, className, classNames })
  
  // Apply highlighting styles when mention is highlighted for deletion
  const highlightedStyles = isHighlighted ? {
    opacity: 0.5,
    backgroundColor: 'rgba(255, 0, 0, 0.1)',
    animation: 'mentionHighlight 2s cubic-bezier(0.42, 0, 0.58, 1) infinite',
  } : {}
  
  return (
    <strong 
      {...styles} 
      style={{ 
        ...styles.style, 
        ...highlightedStyles 
      }}
      data-mention-id={id}
    >
      {display}
    </strong>
  )
}

Mention.propTypes = {
  /**
   * Called when a new mention is added in the input
   *
   * Example:
   *
   * ```js
   * function(id, display) {
   *   console.log("user " + display + " was mentioned!");
   * }
   * ```
   */
  onAdd: PropTypes.func,
  
  /**
   * Called when a mention is removed from the input
   *
   * Example:
   *
   * ```js
   * function(id, display, start, end) {
   *   console.log("user " + display + " was removed!");
   * }
   * ```
   */
  onRemove: PropTypes.func,

  renderSuggestion: PropTypes.func,

  trigger: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(RegExp),
  ]),
  markup: PropTypes.string,
  displayTransform: PropTypes.func,
  /**
   * If set to `true` spaces will not interrupt matching suggestions
   */
  allowSpaceInQuery: PropTypes.bool,

  isLoading: PropTypes.bool,
  
  /**
   * Maximum number of mentions allowed for this trigger type
   */
  maxMentions: PropTypes.number,
  
  /**
   * Whether this mention is highlighted for deletion
   */
  isHighlighted: PropTypes.bool,
  
  /**
   * The unique identifier for this mention
   */
  id: PropTypes.string,
  
  /**
   * Display text for the mention
   */
  display: PropTypes.string,
  
  /**
   * Style object for the mention
   */
  style: PropTypes.object,
  
  /**
   * CSS class name
   */
  className: PropTypes.string,
  
  /**
   * CSS class names object
   */
  classNames: PropTypes.object,
}


export default Mention
